var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bold)?_c('strong',{class:[_vm.enumValue.class],domProps:{"textContent":_vm._s(_vm.$t(_vm.enumValue.i18nKey))}}):_c('span',{class:[_vm.enumValue.class],domProps:{"textContent":_vm._s(_vm.$t(_vm.enumValue.i18nKey))}})}
var staticRenderFns = []

export { render, staticRenderFns }